var React = require('react');

function Passenger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.478 10.058c-.505-.176-1.331-.23-1.692-.37-.253-.099-.655-.203-.781-.361-.131-.153-.131-1.268-.131-1.268s.316-.293.447-.623c.131-.329.217-1.223.217-1.223s.027.009.068.009c.095 0 .266-.063.347-.478.099-.51.289-.776.239-1.151-.036-.252-.145-.293-.208-.293-.032 0-.054.009-.054.009s.257-.379.257-1.669C9.187 1.313 8.163.005 6.272 0 4.377.005 3.357 1.313 3.357 2.64c0 1.286.257 1.67.257 1.67s-.022-.01-.054-.01c-.068 0-.176.041-.208.293-.05.375.135.645.239 1.151.081.415.253.478.347.478.041 0 .068-.009.068-.009s.086.898.217 1.223c.131.33.447.623.447.623s0 1.115-.131 1.268-.528.262-.78.361c-.361.14-1.187.194-1.692.37C1.561 10.234 0 10.969 0 13h12.544c0-2.031-1.556-2.766-2.066-2.942z"}));
}

Passenger.defaultProps = {"width":"12.544","height":"13","viewBox":"0 0 12.544 13"};

module.exports = Passenger;

Passenger.default = Passenger;
